<div *ngIf="!showRequest">
  <h2 *ngIf="isShow" class="sectionTitle">{{'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.FORM_TITLE' | translate }}
  </h2>

  <div *ngIf="baseRequestId" class="read-only-content">
    <!-- request Details summary -->
    <app-transit-request #TransitRequest [IsAdminMode]="true" (isPaidFlag)="receivePaidFlag($event)"
      (FeesEstimateObjValue)="receiveFeesValue($event)" (FeesEstimationValidation)="receiveFeesEstimationValidation($event)"> </app-transit-request>
  </div>

  <div *ngIf="showTransitIssueDescription" class="bs-callout bs-callout-info">
    <h4>{{'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.TRANSIT_ISSUE_DESCRIPTION' | translate}}</h4>
    <p>{{ transitIssueDescription }}</p>
  </div>

  <div *ngIf="baseRequestId">
    <form [formGroup]="issueResolutionForm">
      <div class="form-container">
        <div class="form-section">
          <h4 class="section-title">{{'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.DECISION_SECTION' | translate}}
          </h4>
          <div class="form-group">
            <label>{{'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.DECISION_LABEL' | translate}} <span
                class="red">*</span></label>
            <div class="form-custom-inputs">
              <div *ngFor="let opt of decisionKeys" class="custom-Radio">
                <input type="radio" [id]="opt" [value]="decision[opt]" formControlName="Decision" name="Decision"
                  (change)="changeDecision(decision[opt])" />
                <label [for]="opt">{{ 'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.' + opt | translate }}</label>
              </div>
            </div>
            <div *ngIf="submitted || (f.Decision?.dirty && f.Decision?.errors)" class="red">
              <div *ngIf="f.Decision?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>

          <!-- File Uploader - Only appears for Upload Clearance -->
          <div class="form-group" *ngIf="decisionValue === decision.UPLOAD_CLEARANCE">
            <label for="clearanceEvidence">{{'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.CLEARANCE_EVIDENCE' |
              translate}}</label>

            <!-- show existing uploaded file when in readonly/view mode -->
            <div class="form-group read-uploaded" *ngIf="formMode != FormMode.Add && docURL">
              <!-- <label>{{ 'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.CLEARANCE_EVIDENCE_File' | translate}}</label> -->
              <a id="uploaderClearanceEvidenceURL" href="{{docURL}}" target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
              </a>
            </div>

            <div *ngIf="formMode != FormMode.Readonly">
              <!-- Uploader -->
              <input type="file" formControlName="ClearanceEvidence" id="uploaderClearanceEvidence" class="form-control"
                name="uploaderClearanceEvidence" MaxSizeInMB="5"
                accept=".pdf,.PDF,.gif,.GIF,.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.doc,.DOC,.docx,.DOCX"
                (change)="onClearanceFileSelected($event)" />

              <!-- Description About File [Size - Allowed EXT.] -->
              <div class="upload-info">
                <span data-toggle="tooltip"
                  title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle'
                  | translate}}</span>
                <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
              </div>

              <!-- Progress Bar -->
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="clearanceEvidenceProgress + '%'">
                  <span class=""> {{clearanceEvidenceProgress}} % Complete</span>
                </div>
              </div>

              <!-- Required validate Message -->
              <div *ngIf="f.ClearanceEvidence?.dirty && f.ClearanceEvidence?.invalid" class="red">
                <div *ngIf="f.ClearanceEvidence?.errors?.notCompleted">
                  {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                </div>
              </div>
            </div>
          </div>

          <!-- Edit Transit Date -->
          <div *ngIf="decisionValue === decision.EDIT_TRANSIT_DATE" class="form-group">
            <label for="TransitDate">{{'SHARED.REPORTS.EBOOKING_OBJECT_EXPORTING.TransitDate'| translate}}</label>
            <span class="red"> *</span>
            <input #TransitDateDatepicker="bsDatepicker" bsDatepicker formControlName="TransitDate"
              [minDate]='minTransitDate' [bsConfig]="{dateInputFormat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
              id="TransitDate" class="form-control" name="TransitDate" />
            <!-- {{ f.TransitDate?.errors | json}}
            {{ f.TransitDate?.hasError('sameAsCurrent') }} -->
            <div *ngIf="(submitted || f.TransitDate?.dirty) && f.TransitDate?.errors" class="red">
              <div *ngIf="f.TransitDate?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.TransitDate?.hasError('sameAsCurrent')">
                {{('FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.SAME_AS_CURRENT_DATE' | translate) + ' (' +
                (TransitRequest?.transitRequest?.AgentTransitDate | date:'yyyy-MM-dd') + ')'}}
                </div>
                <div *ngIf="f.TransitDate?.hasError('exceedFeesEstimationExpiration')">
                  {{('FRONT_USER.FEES_ESTIMATION_FORM.COMPARE_TRANSIT_EXPIRE_DATES_ERROR' | translate) + ' (' +
                  (feesEstimationExpiration
                  | date:'yyyy-MM-dd') + ')'}}
              </div>
            </div>
          </div>

          <!-- Refund Request -->
          <div class="form-group" *ngIf="decisionValue === decision.CANCEL_TRANSIT_PAID">
            <label><span class="red">*</span>
              <input type="checkbox" id="RequestRefund" formControlName="RequestRefund" />
              {{ 'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.REQUEST_REFUND' | translate }}
            </label>


            <!-- Validation message if not checked -->
            <div *ngIf="submitted && f.RequestRefund?.errors" class="red">
              <div *ngIf="f.RequestRefund?.errors?.required">
                {{ 'FRONT_USER.This_Field_Is_Required' | translate }}
              </div>
            </div>

            <!-- Confirmation message shown when checked -->
            <div *ngIf="f.RequestRefund?.value" class="alert alert-info mt-2">
              {{ 'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.REQUEST_REFUND_MESSAGE' | translate }}
            </div>
          </div>

        </div>
        <!-- Penalties Commitment -->
        <div class="form-section"
          *ngIf="decisionValue === decision.EDIT_TRANSIT_DATE || decisionValue === decision.CANCEL_TRANSIT_PAID || decisionValue === decision.CANCEL_TRANSIT_NOTPAID || decisionValue === decision.UPLOAD_CLEARANCE">
          <label><span class="red">*</span>
            <input type="checkbox" id="CommitToPayPenalties" formControlName="CommitToPayPenalties" />
            {{ 'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.COMMIT_TO_PAY_PENALTIES' | translate }}
          </label>

          <!-- Validation message if not checked -->
          <div *ngIf="submitted && f.CommitToPayPenalties?.errors" class="red">
            <div *ngIf="f.CommitToPayPenalties?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}
            </div>
          </div>

          <!-- Confirmation message shown when checked -->
          <div *ngIf="f.CommitToPayPenalties?.value" class="alert alert-info mt-2" style="white-space: pre-line;">
            {{ 'FRONT_USER.TRANSIT.TRANSIT_ISSUE_RESOLUTION_FORM.COMMIT_TO_PAY_PENALTIES_MESSAGE' | translate }}
          </div>
        </div>
      </div>

      <div *ngIf="formMode == FormMode.Add" class="form-group">
        <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{
          'FRONT_USER.SUBMIT' | translate}}</button>
      </div>
    </form>
  </div>
</div>

<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/myTasks">
        {{ 'FRONT_USER.WORKSPACE.MY_TASKS' | translate }}</a></p>
  </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/myTasks">
        {{ 'FRONT_USER.WORKSPACE.MY_TASKS' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/myTasks">
        {{ 'FRONT_USER.WORKSPACE.MY_TASKS' | translate }}</a></p>
  </div>
</div>